/**
 * Base64-encodes a URL so the Cloudflare WAF doesn't reject the request body.
 *
 * Plain URL percent-encoding is insufficient because the WAF normalizes one
 * `%XX` decoding pass before evaluating its rules, so trigger substrings
 * (e.g. `.aspx`, `.jsp`, private IPs, `Login?ReturnUrl=`) reappear and fire
 * the rule. Base64 output only contains `[A-Za-z0-9+/=]` and is not
 * pre-decoded by the WAF, so trigger substrings never appear in the body.
 *
 * The `unescape(encodeURIComponent(...))` chain is the standard idiom for
 * UTF-8-safe `btoa`, since `btoa` itself only handles Latin-1 input.
 */
export const encodeUrlForWaf = (url: string): string => btoa(unescape(encodeURIComponent(url)))
